import { zoomInElement, zoomOutElement, fadeInElement, fadeOutElement } from '@/views/situationRoom/animation/zoomAndFade';
import { IDLE_SECONDS_MIN, INTERVAL_SECONDS_MIN, SECONDS_MAX, defaultAutoDemoSettings } from './dataSettings';
export default {
  name: 'SettingsModal',
  props: {
    settings: {
      type: Object,
      default: function _default() {
        return defaultAutoDemoSettings;
      }
    },
    allSiteOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      IDLE_SECONDS_MIN: IDLE_SECONDS_MIN,
      INTERVAL_SECONDS_MIN: INTERVAL_SECONDS_MIN,
      SECONDS_MAX: SECONDS_MAX,
      isFocus: false
    };
  },
  computed: {
    hasError: function hasError() {
      var _this$settings$siteId;
      return this.settings.openDemo && !((_this$settings$siteId = this.settings.siteIds) !== null && _this$settings$siteId !== void 0 && _this$settings$siteId.length);
    }
  },
  methods: {
    fixIdleSeconds: function fixIdleSeconds(s) {
      this.$emit('fix-idle-seconds', s);
    },
    fixIntervalSeconds: function fixIntervalSeconds(s) {
      this.$emit('fix-interval-seconds', s);
    },
    submitSettings: function submitSettings() {
      if (this.hasError) return;
      this.$emit('submit-settings');
      this.handleCloseModal(); // 這個才有關閉 animation
    },
    resetSettings: function resetSettings() {
      this.$emit('reset-settings');
    },
    handleCloseModal: function handleCloseModal() {
      var _this = this;
      if (this.isFocus) {
        this.isFocus = false;
        return;
      }
      zoomOutElement(this.$refs.modalMain, 0.4);
      fadeOutElement(this.$refs.modalBk, 0.4, function () {
        _this.$emit('close-modal');
      });
      this.isFocus = false;
    }
  },
  mounted: function mounted() {
    fadeInElement(this.$refs.modalBk, 0.4);
    zoomInElement(this.$refs.modalMain, 0.4);
  }
};